module.exports = __webpack_public_path__ + "img/top.9e67034b.png";